export type DiffOp = {
  type: 'equal' | 'delete' | 'insert';
  value: string;
};

export function tokenizeForDiff(text: string): string[] {
  return String(text || '').match(/\s+|[^\s]+/g) || [];
}

function mergeOps(ops: DiffOp[]): DiffOp[] {
  const merged: DiffOp[] = [];
  for (const op of ops) {
    const last = merged[merged.length - 1];
    if (last && last.type === op.type) {
      last.value += op.value;
    } else {
      merged.push({ ...op });
    }
  }
  return merged;
}

export function diffTokens(original: string, proposed: string): DiffOp[] {
  const a = tokenizeForDiff(original);
  const b = tokenizeForDiff(proposed);
  const n = a.length;
  const m = b.length;
  const dp: number[][] = Array.from({ length: n + 1 }, () => new Array(m + 1).fill(0));

  for (let i = n - 1; i >= 0; i -= 1) {
    for (let j = m - 1; j >= 0; j -= 1) {
      dp[i][j] = a[i] === b[j]
        ? dp[i + 1][j + 1] + 1
        : Math.max(dp[i + 1][j], dp[i][j + 1]);
    }
  }

  const ops: DiffOp[] = [];
  let i = 0;
  let j = 0;
  while (i < n && j < m) {
    if (a[i] === b[j]) {
      ops.push({ type: 'equal', value: a[i] });
      i += 1;
      j += 1;
    } else if (dp[i + 1][j] >= dp[i][j + 1]) {
      ops.push({ type: 'delete', value: a[i] });
      i += 1;
    } else {
      ops.push({ type: 'insert', value: b[j] });
      j += 1;
    }
  }
  while (i < n) {
    ops.push({ type: 'delete', value: a[i] });
    i += 1;
  }
  while (j < m) {
    ops.push({ type: 'insert', value: b[j] });
    j += 1;
  }
  return mergeOps(ops);
}
